export default __webpack_public_path__ + "static/media/green-spring-leaves.37dd40a1.png";